module.exports = __webpack_public_path__ + "static/media/Instagram.11881dc7.svg";